// store.ts
import { postsApi } from "@/services/posts/postsApi";
import { combineReducers, configureStore } from "@reduxjs/toolkit";

// Example custom logger
const loggerMiddleware = (storeAPI: any) => (next: any) => (action: any) => {
  console.log("dispatching", action);
  const result = next(action);
  console.log("next state", storeAPI.getState());
  return result;
};

const rootReducer = combineReducers({
  [postsApi.reducerPath]: postsApi.reducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(
        postsApi.middleware, // from RTK Query
        loggerMiddleware // custom logger
      ),
  });
};

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
